<div class="post-bar">
    <a routerLink="/work" class="all-posts">
        <h5>View All Work</h5>
        <span></span>
    </a>
</div>